export default "__VITE_ASSET__CxgDmlI7__"